<div odxLayout="flex gap-none" class="h-100 flex-column odx-bar-parent">
  <app-project-detail-header
    class="w-100"
    [project]="activeProject"
    [activeFloorplan]="activeFloorplan"
    (navigateBack)="navigateBack()"
  ></app-project-detail-header>

  <div class="planner-wrapper h-100">
    <div
      id="floorplan-container"
      #floorplanContainer
      class="h-100 w-100"
      (mouseenter)="onEnterFloorplan()"
      (mouseleave)="onLeaveFloorplan()"
    ></div>
    <div id="floorplan-controls">
      <app-floorplan-opacity-menu></app-floorplan-opacity-menu>

      <odx-button-group [block]="true" [vertical]="true" [reverse]="false" [alignRight]="true">
        <button odxButton (click)="onZoomIn()" [odxTooltip]="tooltipTextZoomIn">
          <odx-icon name="zoom-in" size="medium"></odx-icon>
        </button>
        <button odxButton (click)="onZoomOut()" [odxTooltip]="tooltipTextZoomOut">
          <odx-icon name="zoom-out" size="medium"></odx-icon>
        </button>
        <button odxButton (click)="onResetZoom()" [odxTooltip]="tooltipTextResetZoom">
          <odx-icon name="zoom-original" size="medium"></odx-icon>
        </button>
      </odx-button-group>
    </div>
  </div>
  <app-floorplan-multi-select-bar [activeFloorplan]="activeFloorplan"></app-floorplan-multi-select-bar>
</div>
<div class="floorplan-selector">
  <app-floorplan-selector [activeFloorplan]="activeFloorplan"></app-floorplan-selector>
</div>
<div class="menu-container w-100 space-between" odxLayout="flex">
  @if ((isReadOnlyUser$ | async) === false) {
    <app-floorplan-menu
      [activeFloorplan]="activeFloorplan"
      [hidden]="(hasWritePermission$ | async) === false"
    ></app-floorplan-menu>
  }

  <app-floorplan-additional-notes></app-floorplan-additional-notes>
</div>
